import React, { useMemo, useState } from "react";
import * as S from "./styles";
import { Canal } from "./canal";
import { TipoComunicado } from "./tipo-comunicado";
import { TipoDivida } from "./tipo-divida";
import { ConfiguracaoComunicado } from "./configuracao-comunicado";

type Item =
  | "Configuração Comunicado"
  | "Tipo Comunicado"
  | "Tipo Divida"
  | "Canal";

const MENU_LIST: Item[] = [
  "Configuração Comunicado",
  "Tipo Comunicado",
  "Tipo Divida",
  "Canal",
];

export const Comunicado: React.FC = () => {
  const [menu, setMenu] = useState<Item>("Configuração Comunicado");

  const menuItem = useMemo(() => {
    switch (menu) {
      case "Configuração Comunicado":
        return <ConfiguracaoComunicado />;
      case "Tipo Comunicado":
        return <TipoComunicado />;
      case "Tipo Divida":
        return <TipoDivida />;
      default:
        return <Canal />;
    }
  }, [menu]);

  return (
    <S.Container>
      <S.SideMenu>
        {MENU_LIST.map((item: Item, i: number) => (
          <S.ItemMenu
            key={i}
            onClick={() => setMenu(item)}
            active={item === menu}
          >
            {item}
          </S.ItemMenu>
        ))}
      </S.SideMenu>
      {menuItem}
    </S.Container>
  );
};
